import { render, staticRenderFns } from "./ed-homework-grade.vue?vue&type=template&id=4e74790f&scoped=true&"
import script from "./ed-homework-grade.ts?vue&type=script&lang=js&"
export * from "./ed-homework-grade.ts?vue&type=script&lang=js&"
import style0 from "./ed-homework-grade.scss?vue&type=style&index=0&id=4e74790f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74790f",
  null
  
)

export default component.exports